import React, { useState } from 'react';
import { IconChevronLeft, IconChevronRight } from '@veneer/core';
import {
  Card,
  ImageWrapper,
  CardImage,
  Content,
  Title,
  Highlight,
  Description,
  Chevron
} from './styles';
import {
  truncate,
  isNonEmptyString,
  OfferData
} from '@uma/react-commons/dist/index';

interface OfferCardProps {
  offer: OfferData;
  isRtl: boolean;
  onClick: () => void;
}

export const OfferCard: React.FC<OfferCardProps> = ({
  offer,
  isRtl,
  onClick
}) => {
  const { title, hyperlinkText, description, storeUrl, imageUrl } = offer;
  const [isImageLoading, setIsImageLoading] = useState(true);

  const handleImageLoad = () => {
    setIsImageLoading(false);
  };

  return (
    <Card
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      {imageUrl && (
        <ImageWrapper>
          <CardImage
            src={imageUrl}
            alt={title}
            loading="lazy"
            decoding="async"
            onLoad={handleImageLoad}
            $isLoading={isImageLoading}
          />
        </ImageWrapper>
      )}
      <Content>
        <Title>{truncate(title, 90)}</Title>
        <Highlight
          href={storeUrl}
          onClick={(e: {
            preventDefault: () => void;
            stopPropagation: () => void;
          }) => {
            e.preventDefault();
            e.stopPropagation();
            onClick();
          }}
        >
          {truncate(hyperlinkText, 140)}
        </Highlight>
        {isNonEmptyString(description) && (
          <Description>{truncate(description || '', 240)}</Description>
        )}
      </Content>
      <Chevron>{isRtl ? <IconChevronLeft /> : <IconChevronRight />}</Chevron>
    </Card>
  );
};
